import { useState } from 'react';
import CollapsableControl from '../collapsable-controls/collapsable-controls';
import CollapsableMessagesPanel from '../collapsable-messages-panel/collapsable-messages-panel';
import { CollapsableEditModeI, CollapsableSize, Comment } from '../types/ui-kit.types';

interface CollapsablePanelI {
    size: CollapsableSize;
    comments: Comment[];
    isLoadingMessages: boolean;
    isLoadingActions: boolean;
    emptyMessage: string;
    collapsableId: string;
    onEdit?(collapsableId: string, commentId: string, message: string): Promise<unknown>;
    onCreate?(collapsableId: string, message: string): Promise<unknown>;
    onDelete?(id: string): Promise<unknown>;
    disableComment?: boolean;
}

const CollapsablePanel = ({
    size,
    comments,
    isLoadingMessages,
    isLoadingActions,
    emptyMessage,
    collapsableId,
    onEdit,
    onCreate,
    onDelete,
    disableComment,
}: CollapsablePanelI) => {
    const [newComment, setNewComment] = useState<string>('');
    const [editMode, setEditMode] = useState<CollapsableEditModeI>({ editedCommentId: '', isEditing: false });

    const toggleEditMode = (id: string, message: string, state: boolean) => {
        setNewComment(message);
        setEditMode({
            editedCommentId: id,
            isEditing: state,
        });
    };
    const handleDelete = (id: string) => {
        setEditMode((prevState) => ({ ...prevState, editedCommentId: id }));
        onDelete &&
            onDelete(id).finally(() => {
                setEditMode((prevState) => ({ ...prevState, editedCommentId: '' }));
            });
    };
    const handleEdit = () => {
        if (onEdit) {
            onEdit(collapsableId, editMode.editedCommentId, newComment).finally(() => {
                toggleEditMode('', '', false);
            });
        }
    };
    const handleCreate = () => {
        if (onCreate) {
            onCreate(collapsableId, newComment).finally(() => {
                toggleEditMode('', '', false);
            });
        }
    };
    return (
        <>
            <CollapsableMessagesPanel
                size={size}
                comments={comments}
                isLoadingMessages={isLoadingMessages}
                isLoadingActions={isLoadingActions}
                editMode={editMode}
                emptyMessage={emptyMessage}
                onEdit={disableComment ? undefined : (id: string, message: string) => toggleEditMode(id, message, true)}
                onDelete={disableComment ? undefined : handleDelete}
            />
            <CollapsableControl
                collapsableId={collapsableId}
                placeholder={'Comentario'}
                isLoading={isLoadingActions}
                isEditing={editMode.isEditing}
                comment={newComment}
                onChange={(inputComment: string) => setNewComment(inputComment)}
                onEdit={handleEdit}
                onCreate={handleCreate}
                handleResetEditMode={() => toggleEditMode('', '', false)}
                disabled={disableComment}
            />
        </>
    );
};

export default CollapsablePanel;
